

/**
 * Car rental fixed disclaimer fixed text. 
 */
export const CAR_RENTAL_DISCLAIMER_TEXT = `In allegato trovi due file:
Le istruzioni da seguire prima, durante e dopo il tuo noleggio auto.

Il voucher della prenotazione, che dovrai presentare sul posto insieme a:

una patente di guida internazionale in corso di validità

una carta di credito a tuo nome (non sono accettate carte di debito)

Ti raccomandiamo di leggere attentamente tutte le informazioni e le condizioni riportate nei PDF allegati.
`;

export const CAR_RENTAL_WHAT_INCLUDED_TEXT = `Chilometraggio illimitato – Assicurazione contro i danni da collisione (con franchigia) – Assicurazione furto (con franchigia) – Assicurazione responsabilità civile – Tasse locali – Tasse aeroportuali`;

export const TRAIN_TICKET_DISCLAIMER_TEXT = `È importante arrivare almeno 15 minuti prima dell’orario di partenza.

In caso di ritardo o cancellazione del treno, è necessario recarsi direttamente all’info point in stazione per ottenere la sostituzione del biglietto.`

export const FERRY_TICKET_DISCLAIMER_TEXT = `Si raccomanda di arrivare al porto almeno 20 minuti prima della partenza, così da avere il tempo necessario per le procedure di check-in.

In allegato sono disponibili i voucher da presentare in biglietteria per ritirare i biglietti
`